export default __webpack_public_path__ + "static/media/k_wdt_c_4_5.778c853f.mp3";